/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * FINRA Market Data API
 * Market data aggregation backend for FINRA data sources
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FundCategoryAverages,
  GetFundCategoryAveragesParams,
  HTTPValidationError,
  InternalErrorResponse,
  UpstreamAuthenticationFailedErrorResponse,
  UpstreamBadGatewayErrorResponse,
  UpstreamUnavailableErrorResponse
} from '../fINRAMarketDataAPI.schemas.ts';

import { apiFetch } from '../../../lib/api-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getFundCategoryAveragesResponse200 = {
  data: FundCategoryAverages
  status: 200
}

export type getFundCategoryAveragesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getFundCategoryAveragesResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getFundCategoryAveragesResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getFundCategoryAveragesResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getFundCategoryAveragesResponseSuccess = (getFundCategoryAveragesResponse200) & {
  headers: Headers;
};
export type getFundCategoryAveragesResponseError = (getFundCategoryAveragesResponse422 | getFundCategoryAveragesResponse500 | getFundCategoryAveragesResponse502 | getFundCategoryAveragesResponse503) & {
  headers: Headers;
};

export type getFundCategoryAveragesResponse = (getFundCategoryAveragesResponseSuccess | getFundCategoryAveragesResponseError)

export const getGetFundCategoryAveragesUrl = (params: GetFundCategoryAveragesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/category-averages/?${stringifiedParams}` : `/api/v1/category-averages/`
}

/**
 * Get Morningstar Category Average returns for a fund category.
 *
 * Shared by both the ETF and mutual fund detail pages — lazy-loaded once a
 * fund's category_code is known (from its /detail response's
 * related.category_code). Category averages are keyed purely by
 * category_code, not by fund symbol or type, since the same average applies
 * to every fund classified into that category.
 *
 * Args:
 *     category_code: The fund's Morningstar category code (e.g., "$FOCA$LB$$")
 *     morningstar: Injected MorningstarClient instance
 *
 * Returns:
 *     FundCategoryAverages response model
 *
 * Raises:
 *     500: Morningstar API error or authentication failure
 * @summary Get Fund Category Averages
 */
export const getFundCategoryAverages = async (params: GetFundCategoryAveragesParams, options?: RequestInit): Promise<getFundCategoryAveragesResponse> => {

  return apiFetch<getFundCategoryAveragesResponse>(getGetFundCategoryAveragesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFundCategoryAveragesQueryKey = (params?: GetFundCategoryAveragesParams,) => {
    return [
    `/api/v1/category-averages/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFundCategoryAveragesQueryOptions = <TData = Awaited<ReturnType<typeof getFundCategoryAverages>>, TError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(params: GetFundCategoryAveragesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFundCategoryAverages>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFundCategoryAveragesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFundCategoryAverages>>> = ({ signal }) => getFundCategoryAverages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFundCategoryAverages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFundCategoryAveragesQueryResult = NonNullable<Awaited<ReturnType<typeof getFundCategoryAverages>>>
export type GetFundCategoryAveragesQueryError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetFundCategoryAverages<TData = Awaited<ReturnType<typeof getFundCategoryAverages>>, TError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetFundCategoryAveragesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFundCategoryAverages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFundCategoryAverages>>,
          TError,
          Awaited<ReturnType<typeof getFundCategoryAverages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFundCategoryAverages<TData = Awaited<ReturnType<typeof getFundCategoryAverages>>, TError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetFundCategoryAveragesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFundCategoryAverages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFundCategoryAverages>>,
          TError,
          Awaited<ReturnType<typeof getFundCategoryAverages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFundCategoryAverages<TData = Awaited<ReturnType<typeof getFundCategoryAverages>>, TError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetFundCategoryAveragesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFundCategoryAverages>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Fund Category Averages
 */

export function useGetFundCategoryAverages<TData = Awaited<ReturnType<typeof getFundCategoryAverages>>, TError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 params: GetFundCategoryAveragesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFundCategoryAverages>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFundCategoryAveragesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






